var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.80474 3.52858C10.0651 3.78892 10.0651 4.21103 9.80474 4.47138L6.27614 7.99998L9.80474 11.5286C10.0651 11.7889 10.0651 12.211 9.80474 12.4714C9.54439 12.7317 9.12228 12.7317 8.86193 12.4714L4.86193 8.47138C4.60158 8.21103 4.60158 7.78892 4.86193 7.52858L8.86193 3.52858C9.12228 3.26823 9.54439 3.26823 9.80474 3.52858Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.e132c121.svg";
export { ForwardRef as ReactComponent };